import languages from './languages';

const format = namespaces => {
  return languages.reduce((languages, language) => {
    languages[language] = {};

    for (const [namespaceKey, namespaceValues] of Object.entries(namespaces)) {
      languages[language][namespaceKey] = namespaceValues.reduce(
        (translations, translation) => {
          const match = translation.values.find(
            value => value.language === language
          );
          translations[translation.key] = match ? match.value : '';
          return translations;
        },
        {}
      );
    }

    return languages;
  }, {});
};

export default format;
